import { store } from "../state/store.js";
import { getBandFromFrequency, getIntermediateFrequencyMHz, getPolBandLabel } from "../utils/sat.js";
import { tpKey } from "./tpKey.js";
import { el } from "../utils/dom.js";
import { norm } from "../utils/text.js";
function matchesQuery(tp,q){
  if(!q) return true;
  const hay=[tp.tp_name,tp.provider,tp.sat_pos,tp.frequency_MHz,tp.pol,getPolBandLabel(tp.pol, tp.frequency_MHz),getBandFromFrequency(tp.frequency_MHz),getIntermediateFrequencyMHz(tp.frequency_MHz),tp.symbolrate_kSps,tp.dvb,tp.tsid,tp.onid,tp.tsid_onid].map(v=>String(v??"")).join(" ").toLowerCase();
  if(hay.includes(q)) return true;
  const k=tpKey(tp); const progs=store.programsByTpKey.get(k)||[];
  for(const p of progs){
    const phay=[p.program_name,p.name,p.service_name,p.language,p.type,p.resolution].map(v=>String(v??"")).join(" ").toLowerCase();
    if(phay.includes(q)) return true;
  }
  return false;
}
export function filteredTransponders(){
  const q=norm(el("qTp")?.value||"");
  const sat=String(el("satFilter")?.value||"").trim();
  const sortBy=String(el("sortBy")?.value||"sat_freq");
  let arr=store.transponders.filter(tp=>{ if(sat && String(tp.sat_pos||"")!==sat) return false; return matchesQuery(tp,q); });
  const cmpNum=(a,b)=>(Number(a)||0)-(Number(b)||0);
  if(sortBy==="freq") arr.sort((a,b)=>cmpNum(a.frequency_MHz,b.frequency_MHz));
  else if(sortBy==="provider") arr.sort((a,b)=>String(a.provider||"").localeCompare(String(b.provider||""),"de"));
  else if(sortBy==="tpno") arr.sort((a,b)=>cmpNum(a.tp_no,b.tp_no));
  else arr.sort((a,b)=>String(a.sat_pos||"").localeCompare(String(b.sat_pos||""),"de")||cmpNum(a.frequency_MHz,b.frequency_MHz));
  return arr;
}
export function programCount(tp){ const k=tpKey(tp); return (store.programsByTpKey.get(k)||[]).length; }
